export const getCopilotChatUserId = async (): Promise<string | null> => {
  try {
    
    const response = await fetch(`https://ackodrive.com/p/acko-assist-v2/api/get-or-create-user/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.error(`Failed to get copilot user: ${response.status}`);
      return null;
    }

    const data = await response.json();

    return data.user.chatUserId;
  } catch (error: any) {
    console.error("Error fetching copilot chat user ID", error.message);
    return null;
  }
};